// extracted by mini-css-extract-plugin
export default {"root":"PlasmicCardModalHeader_root__t5CI8","closeButton":"PlasmicCardModalHeader_closeButton__jAUtu"};